<template>
  <div style="position: relative;">
    <el-form ref="UserWorkListFilter" :model="UserWorkList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="UserWorkList.formFilter.status" :clearable="true" filterable
                     placeholder="类型" :loading="UserWorkList.status.impl.loading"
                     @visible-change="UserWorkList.status.impl.onVisibleChange">
            <el-option v-for="item in UserWorkList.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="作品名称" prop="formFilter.workName">
          <el-input class="filter-item" v-model="UserWorkList.formFilter.workName"
            :clearable="true" placeholder="请输入参与作品名称"
          />
        </el-form-item>
        <el-form-item label="人员名称" prop="formFilter.userName">
          <el-input class="filter-item" v-model="UserWorkList.formFilter.userName"
                    :clearable="true" placeholder="请输入参与人员名称"
          />
        </el-form-item>
<!--
        <el-form-item label="大类名称(原始)" prop="formFilter.workBigTypeName">
          <el-input class="filter-item" v-model="UserWorkList.formFilter.workBigTypeName"
            :clearable="true" placeholder="大类名称"
          />
        </el-form-item>
-->
        <!-- ziyi 2022年6月11日 -->
        <el-form-item label="部门" prop="formFilter.bumenmingcheng">
          <el-select class="filter-item" v-model="UserWorkList.formFilter.bumenmingcheng" :clearable="true" filterable
            placeholder="选择部门" :loading="UserWorkList.daleimingchengLv.impl.loading"
            @visible-change="UserWorkList.daleimingchengLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in UserWorkList.daleimingchengLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end-->
<!--
        <el-form-item label="作品类型名称（原始）" prop="formFilter.workTypeName">
          <el-input class="filter-item" v-model="UserWorkList.formFilter.workTypeName"
            :clearable="true" placeholder="作品类型名称"
          />
        </el-form-item>
-->
        <!-- ziyi 2022年6月11日 -->
        <el-form-item label="作品类型" prop="formFilter.zuopinleixingmingceng">
          <el-select class="filter-item" v-model="UserWorkList.formFilter.zuopinleixingmingceng" :clearable="true" filterable
            placeholder="选择作品类型" :loading="UserWorkList.zuopinleixingmingchengLv.impl.loading"
            @visible-change="UserWorkList.zuopinleixingmingchengLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in UserWorkList.zuopinleixingmingchengLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end-->
        <el-form-item label="作品评级" prop="formFilter.assessLv">
          <el-select class="filter-item" v-model="UserWorkList.formFilter.assessLv" :clearable="true" filterable
            placeholder="作品评级" :loading="UserWorkList.assessLv.impl.loading"
            @visible-change="UserWorkList.assessLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in UserWorkList.assessLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="得分" prop="formFilter.score">
          <input-number-range class="filter-item"
            v-model="UserWorkList.formFilter.score" :clearable="true"
            startPlaceholder="最小值" endPlaceholder="最大值"
          />
        </el-form-item>-->
        <!-- ziyi 2022年6月11日 -->
        <el-form-item label="语言类型" prop="formFilter.language">
          <el-select class="filter-item" v-model="UserWorkList.formFilter.language" :clearable="true" filterable placeholder="语言类型">
              <el-option v-for="item in UserWorkList.languageLv"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="formFilter.language">
          <div class="block">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="UserWorkList.formFilter.kaishishijian" type="date" placeholder="选择开始日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="formFilter.language">
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="filter-item" v-model="UserWorkList.formFilter.jiesushijian" type="date" placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- ziyi 2022年6月11日 end -->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetUserWorkList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="onExportClick()">导出</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshUserWorkList(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="paWorkLine" :data="UserWorkList.PaWorkLine.impl.dataList" :size="defaultFormItemSize" @sort-change="UserWorkList.PaWorkLine.impl.onSortChange"
          header-cell-class-name="table-header-gray" height="600px"
          highlight-current-row @current-change="UserWorkList.PaWorkLine.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="UserWorkList.PaWorkLine.impl.getTableIndex" />
          <el-table-column label="状态" prop="statusDictMap.name">
          </el-table-column>
          <el-table-column label="参与作品名称" prop="workName" width="150px">
          </el-table-column>
          <el-table-column label="大类名称" prop="workBigTypeName" width="150px">
          </el-table-column>
          <el-table-column label="作品类型名称" prop="workTypeName" width="150px">
          </el-table-column>
          <el-table-column label="部门名称" prop="deptName">
          </el-table-column>
          <el-table-column label="上传时间" prop="createTime" width="150px">
          </el-table-column>
          <el-table-column label="岗位名称" prop="deptPostName">
          </el-table-column>
          <el-table-column label="员工姓名" prop="userName">
          </el-table-column>
          <el-table-column label="评级" prop="assessLvDictMap.name">
          </el-table-column>
          <el-table-column label="得分" prop="score">
          </el-table-column>
          <el-table-column label="得分说明" prop="scoreDetail">
          </el-table-column>
          <el-table-column label="评价内容" prop="assessDetail" width="250px">
          </el-table-column>
          <el-table-column label="作品链接" prop="workUrl">
            <template slot-scope="scope">
              <a v-if="scope.row.workUrl" :href="scope.row.workUrl" target="view_window">点击访问</a>
            </template>
          </el-table-column>
          <el-table-column label="作品描述" prop="workDetail" width="450px" >
          </el-table-column>
          <el-table-column label="评审人" prop="assessUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="评审时间" prop="assessTime" width="100px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.assessTime, 'day')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="UserWorkList.PaWorkLine.impl.totalCount"
            :current-page="UserWorkList.PaWorkLine.impl.currentPage"
            :page-size="UserWorkList.PaWorkLine.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="UserWorkList.PaWorkLine.impl.onCurrentPageChange"
            @size-change="UserWorkList.PaWorkLine.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {DictionaryController, PaWorkLineController, PaWorkLvScoreController} from '@/api';

export default {
  name: 'UserWorkList',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      UserWorkList: {
        formFilter: {
          status: undefined,
          workName: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          assessLv: undefined,
          score: [],
          language: undefined,
          kaishishijian: undefined,
          jiesushijian: undefined,
          zuopinleixingmingceng:undefined,
          bumenmingcheng:undefined,
          userName:undefined
        },
        formFilterCopy: {
          status: undefined,
          workName: undefined,
          workBigTypeName: undefined,
          workTypeName: undefined,
          assessLv: undefined,
          score: [],
          language:undefined,
          kaishishijian:undefined,
          jiesushijian:undefined,
          zuopinleixingmingceng :undefined,
          bumenmingcheng :undefined,
          userName :undefined
        },
        PaWorkLine: {
          impl: new TableWidget(this.loadPaWorkLineWidgetData, this.loadPaWorkLineVerify, true, true, 'updateTime', 0)
        },
        assessLv: {
          impl: new DropdownWidget(this.loadAssessLvDropdownList)
        },
        daleimingchengLv: {
           impl: new DropdownWidget(this.loaddaleimingchengLvDropdownList)
        },
        zuopinleixingmingchengLv: {
            impl: new DropdownWidget(this.loadzuopinleixingmingchengLvDropdownList)
         },
        languageLv: [{
             value: '汉语',
             label: '汉语'
           }, {
             value: '蒙文',
             label: '蒙文'
        }],
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetUserWorkList () {
      this.$refs.UserWorkListFilter.resetFields();
      this.refreshUserWorkList(true);
    },
    /**
     * 作品行数据获取函数，返回Promise
     */
    loadPaWorkLineWidgetData (params) {
      if (params == null) params = {};

      if (this.UserWorkList.formFilterCopy.kaishishijian && this.UserWorkList.formFilterCopy.jiesushijian) {
        if (new Date(this.UserWorkList.formFilterCopy.kaishishijian).getTime() > new Date(this.UserWorkList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      params = {
        ...params,
        paWorkLineDtoFilter: {
          status: this.UserWorkList.formFilterCopy.status,
          workName: this.UserWorkList.formFilterCopy.workName,
          workBigTypeName: this.UserWorkList.formFilterCopy.workBigTypeName,
          workTypeName: this.UserWorkList.formFilterCopy.workTypeName,
          assessLv: this.UserWorkList.formFilterCopy.assessLv,
          scoreStart: Array.isArray(this.UserWorkList.formFilterCopy.score) ? this.UserWorkList.formFilterCopy.score[0] : undefined,
          scoreEnd: Array.isArray(this.UserWorkList.formFilterCopy.score) ? this.UserWorkList.formFilterCopy.score[1] : undefined,
          language:this.UserWorkList.formFilterCopy.language,
          kaishishijian:this.UserWorkList.formFilterCopy.kaishishijian,
          jiesushijian:this.UserWorkList.formFilterCopy.jiesushijian,
          zuopinleixingmingceng:this.UserWorkList.formFilterCopy.zuopinleixingmingceng,
          bumenmingcheng:this.UserWorkList.formFilterCopy.bumenmingcheng,
          userName:this.UserWorkList.formFilterCopy.userName
        }
      }
      return new Promise((resolve, reject) => {
        PaWorkLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.UserWorkList.PaWorkLine.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.UserWorkList.PaWorkLine.impl.currentRow.id, 'id');
              this.$refs.paWorkLine.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkLineVerify () {
      this.UserWorkList.formFilterCopy.status = this.UserWorkList.formFilter.status;
      this.UserWorkList.formFilterCopy.workName = this.UserWorkList.formFilter.workName;
      this.UserWorkList.formFilterCopy.workBigTypeName = this.UserWorkList.formFilter.workBigTypeName;
      this.UserWorkList.formFilterCopy.workTypeName = this.UserWorkList.formFilter.workTypeName;
      this.UserWorkList.formFilterCopy.assessLv = this.UserWorkList.formFilter.assessLv;
      this.UserWorkList.formFilterCopy.score = this.UserWorkList.formFilter.score;
      this.UserWorkList.formFilterCopy.language = this.UserWorkList.formFilter.language;
      this.UserWorkList.formFilterCopy.kaishishijian = this.UserWorkList.formFilter.kaishishijian;
      this.UserWorkList.formFilterCopy.jiesushijian = this.UserWorkList.formFilter.jiesushijian;
      this.UserWorkList.formFilterCopy.zuopinleixingmingceng = this.UserWorkList.formFilter.zuopinleixingmingceng;
      this.UserWorkList.formFilterCopy.bumenmingcheng = this.UserWorkList.formFilter.bumenmingcheng;
      this.UserWorkList.formFilterCopy.userName = this.UserWorkList.formFilter.userName;
      return true;
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadAssessLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_assess_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    //部门名称下拉选择器
    loaddaleimingchengLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictDaLeiMingCheng(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    //作品类型名称
    loadzuopinleixingmingchengLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {type:'type'};
        DictionaryController.dictSysDictZuoPinLei(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级选中值改变
     */
    onAssessLvValueChange (value) {
      console.log("value-->" + value)
    },
    /**
     * 更新人员作品列表
     */
    refreshUserWorkList (reloadData = false) {
      if (reloadData) {
        this.UserWorkList.PaWorkLine.impl.refreshTable(true, 1);
      } else {
        this.UserWorkList.PaWorkLine.impl.refreshTable();
      }
      if (!this.UserWorkList.isInit) {
        // 初始化下拉数据
      }
      this.UserWorkList.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      this.loadPaWorkLineVerify();
      if (this.UserWorkList.formFilterCopy.kaishishijian && this.UserWorkList.formFilterCopy.jiesushijian) {
        if (new Date(this.UserWorkList.formFilterCopy.kaishishijian).getTime() > new Date(this.UserWorkList.formFilterCopy.jiesushijian).getTime()) {
          this.$message.error('操作失败!开始时间 不能大于 结束时间!');
          return;
        }
      }
      let params = {};
      params = {
        paWorkLineDtoFilter: {
          status: this.UserWorkList.formFilterCopy.status,
          workName: this.UserWorkList.formFilterCopy.workName,
          workBigTypeName: this.UserWorkList.formFilterCopy.workBigTypeName,
          workTypeName: this.UserWorkList.formFilterCopy.workTypeName,
          assessLv: this.UserWorkList.formFilterCopy.assessLv,
          scoreStart: Array.isArray(this.UserWorkList.formFilterCopy.score) ? this.UserWorkList.formFilterCopy.score[0] : undefined,
          scoreEnd: Array.isArray(this.UserWorkList.formFilterCopy.score) ? this.UserWorkList.formFilterCopy.score[1] : undefined,
          language:this.UserWorkList.formFilterCopy.language,
          kaishishijian:this.UserWorkList.formFilterCopy.kaishishijian,
          jiesushijian:this.UserWorkList.formFilterCopy.jiesushijian,
          zuopinleixingmingceng:this.UserWorkList.formFilterCopy.zuopinleixingmingceng,
          bumenmingcheng:this.UserWorkList.formFilterCopy.bumenmingcheng,
          userName:this.UserWorkList.formFilterCopy.userName
        }
        //, ...params
      }
      PaWorkLineController.export(this, params, '作品记录.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshUserWorkList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshUserWorkList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
